import { render } from "./UpdateProfilePictureForm.vue?vue&type=template&id=59620f9c&scoped=true&ts=true"
import script from "./UpdateProfilePictureForm.vue?vue&type=script&lang=ts"
export * from "./UpdateProfilePictureForm.vue?vue&type=script&lang=ts"

import "./UpdateProfilePictureForm.vue?vue&type=style&index=0&id=59620f9c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59620f9c"]])

export default __exports__